module.exports = __webpack_public_path__ + "static/media/me.c0d77405.mp3";